/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AddInteractionLabelReq,
  AppApiPlatformInteractionsPutAvailableCustomColumnsReq,
  CustomInteractionColumn,
  DeleteAvailableCustomColumnsReq,
  DeleteInteractionLabelReq,
  FavoritesCountReq,
  FavoritesCountResp,
  GetAvailableCustomColumnsReq,
  GetAvailableCustomColumnsRes,
  GetAvailableInteractionLabelsReq,
  GetAvailableInteractionLabelsRes,
  GetInteractionAggregatesReq,
  GetInteractionMultiAggregatesReq,
  GetInteractionTimeSeriesReq,
  GetInteractionTimeSeriesResp,
  GetInteractionsReq,
  HTTPValidationError,
  IgnoreModelIssueReq,
  InteractionDetailsByFiltersReq,
  InteractionDetailsByFiltersRes,
  InteractionDetailsReq,
  InteractionDetailsRes,
  InteractionGetAvailableTagsReq,
  InteractionGetAvailableTagsRes,
  InteractionLabel,
  InteractionQueryOptions,
  PaginatedExtendedGroupByQuery,
  PaginatedGroupByQueryMultiple,
  PaginatedInteractionsQueryDetailed,
  ResponseMessage,
  TimeRangeConfig,
  UpdateFieldReq,
} from '../model';

import { customFetch } from '../../fetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetInteractionDetailsUrl = () => {
  return `/api/v1/interactions/details`;
};

/**
 * @summary Get Interaction Details
 */
export const getInteractionDetails = async (
  interactionDetailsReq: InteractionDetailsReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<InteractionDetailsRes> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<InteractionDetailsRes>(getGetInteractionDetailsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(interactionDetailsReq),
  });
};

export const getGetInteractionDetailsMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getInteractionDetails>>,
    TError,
    GetInteractionDetailsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getInteractionDetails>>,
  TError,
  GetInteractionDetailsMutationVariables,
  TContext
> => {
  const mutationKey = ['getInteractionDetails'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getInteractionDetails>>,
    GetInteractionDetailsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getInteractionDetails(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetInteractionDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof getInteractionDetails>>>;
export type GetInteractionDetailsMutationBody = InteractionDetailsReq;
export type GetInteractionDetailsMutationError = HTTPValidationError;
export type GetInteractionDetailsMutationVariables = { data: InteractionDetailsReq };

/**
 * @summary Get Interaction Details
 */
export const useGetInteractionDetails = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getInteractionDetails>>,
    TError,
    GetInteractionDetailsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getInteractionDetails>>,
  TError,
  GetInteractionDetailsMutationVariables,
  TContext
> => {
  return useMutation(getGetInteractionDetailsMutationOptions(options));
};
export const getInteractionIdByFiltersUrl = () => {
  return `/api/v1/interactions/interaction-id-by-filters`;
};

/**
 * @summary Interaction Id By Filters
 */
export const interactionIdByFilters = async (
  interactionDetailsByFiltersReq: InteractionDetailsByFiltersReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<InteractionDetailsByFiltersRes> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<InteractionDetailsByFiltersRes>(getInteractionIdByFiltersUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(interactionDetailsByFiltersReq),
  });
};

export const getInteractionIdByFiltersMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof interactionIdByFilters>>,
    TError,
    InteractionIdByFiltersMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof interactionIdByFilters>>,
  TError,
  InteractionIdByFiltersMutationVariables,
  TContext
> => {
  const mutationKey = ['interactionIdByFilters'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof interactionIdByFilters>>,
    InteractionIdByFiltersMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return interactionIdByFilters(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InteractionIdByFiltersMutationResult = NonNullable<Awaited<ReturnType<typeof interactionIdByFilters>>>;
export type InteractionIdByFiltersMutationBody = InteractionDetailsByFiltersReq;
export type InteractionIdByFiltersMutationError = HTTPValidationError;
export type InteractionIdByFiltersMutationVariables = { data: InteractionDetailsByFiltersReq };

/**
 * @summary Interaction Id By Filters
 */
export const useInteractionIdByFilters = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof interactionIdByFilters>>,
    TError,
    InteractionIdByFiltersMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof interactionIdByFilters>>,
  TError,
  InteractionIdByFiltersMutationVariables,
  TContext
> => {
  return useMutation(getInteractionIdByFiltersMutationOptions(options));
};
export const getGetAvailableTagsUrl = () => {
  return `/api/v1/interactions/get-available-tags`;
};

/**
 * @summary Get Available Tags
 */
export const getAvailableTags = async (
  interactionGetAvailableTagsReq: InteractionGetAvailableTagsReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<InteractionGetAvailableTagsRes> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<InteractionGetAvailableTagsRes>(getGetAvailableTagsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(interactionGetAvailableTagsReq),
  });
};

export const getGetAvailableTagsMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAvailableTags>>,
    TError,
    GetAvailableTagsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAvailableTags>>,
  TError,
  GetAvailableTagsMutationVariables,
  TContext
> => {
  const mutationKey = ['getAvailableTags'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAvailableTags>>,
    GetAvailableTagsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getAvailableTags(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAvailableTagsMutationResult = NonNullable<Awaited<ReturnType<typeof getAvailableTags>>>;
export type GetAvailableTagsMutationBody = InteractionGetAvailableTagsReq;
export type GetAvailableTagsMutationError = HTTPValidationError;
export type GetAvailableTagsMutationVariables = { data: InteractionGetAvailableTagsReq };

/**
 * @summary Get Available Tags
 */
export const useGetAvailableTags = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAvailableTags>>,
    TError,
    GetAvailableTagsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getAvailableTags>>,
  TError,
  GetAvailableTagsMutationVariables,
  TContext
> => {
  return useMutation(getGetAvailableTagsMutationOptions(options));
};
export const getGetInteractionAggregatesUrl = () => {
  return `/api/v1/interactions/interaction-aggregates-v2`;
};

/**
 * @summary Interaction Aggregates V2
 */
export const getInteractionAggregates = async (
  getInteractionAggregatesReq: GetInteractionAggregatesReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedExtendedGroupByQuery> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<PaginatedExtendedGroupByQuery>(getGetInteractionAggregatesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getInteractionAggregatesReq),
  });
};

export const getGetInteractionAggregatesMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getInteractionAggregates>>,
    TError,
    GetInteractionAggregatesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getInteractionAggregates>>,
  TError,
  GetInteractionAggregatesMutationVariables,
  TContext
> => {
  const mutationKey = ['getInteractionAggregates'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getInteractionAggregates>>,
    GetInteractionAggregatesMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getInteractionAggregates(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetInteractionAggregatesMutationResult = NonNullable<Awaited<ReturnType<typeof getInteractionAggregates>>>;
export type GetInteractionAggregatesMutationBody = GetInteractionAggregatesReq;
export type GetInteractionAggregatesMutationError = HTTPValidationError;
export type GetInteractionAggregatesMutationVariables = { data: GetInteractionAggregatesReq };

/**
 * @summary Interaction Aggregates V2
 */
export const useGetInteractionAggregates = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getInteractionAggregates>>,
    TError,
    GetInteractionAggregatesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getInteractionAggregates>>,
  TError,
  GetInteractionAggregatesMutationVariables,
  TContext
> => {
  return useMutation(getGetInteractionAggregatesMutationOptions(options));
};
export const getGetAvailableCustomColumnsUrl = () => {
  return `/api/v1/interactions/get-available-custom-columns`;
};

/**
 * @summary Get Available Custom Columns
 */
export const getAvailableCustomColumns = async (
  getAvailableCustomColumnsReq: GetAvailableCustomColumnsReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetAvailableCustomColumnsRes> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GetAvailableCustomColumnsRes>(getGetAvailableCustomColumnsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getAvailableCustomColumnsReq),
  });
};

export const getGetAvailableCustomColumnsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAvailableCustomColumns>>,
    TError,
    GetAvailableCustomColumnsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAvailableCustomColumns>>,
  TError,
  GetAvailableCustomColumnsMutationVariables,
  TContext
> => {
  const mutationKey = ['getAvailableCustomColumns'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAvailableCustomColumns>>,
    GetAvailableCustomColumnsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getAvailableCustomColumns(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAvailableCustomColumnsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAvailableCustomColumns>>
>;
export type GetAvailableCustomColumnsMutationBody = GetAvailableCustomColumnsReq;
export type GetAvailableCustomColumnsMutationError = HTTPValidationError;
export type GetAvailableCustomColumnsMutationVariables = { data: GetAvailableCustomColumnsReq };

/**
 * @summary Get Available Custom Columns
 */
export const useGetAvailableCustomColumns = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAvailableCustomColumns>>,
    TError,
    GetAvailableCustomColumnsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getAvailableCustomColumns>>,
  TError,
  GetAvailableCustomColumnsMutationVariables,
  TContext
> => {
  return useMutation(getGetAvailableCustomColumnsMutationOptions(options));
};
export const getPutAvailableCustomColumnsUrl = () => {
  return `/api/v1/interactions/available-custom-columns`;
};

/**
 * @summary Put Available Custom Columns
 */
export const putAvailableCustomColumns = async (
  appApiPlatformInteractionsPutAvailableCustomColumnsReq: AppApiPlatformInteractionsPutAvailableCustomColumnsReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomInteractionColumn[]> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CustomInteractionColumn[]>(getPutAvailableCustomColumnsUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(appApiPlatformInteractionsPutAvailableCustomColumnsReq),
  });
};

export const getPutAvailableCustomColumnsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAvailableCustomColumns>>,
    TError,
    PutAvailableCustomColumnsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putAvailableCustomColumns>>,
  TError,
  PutAvailableCustomColumnsMutationVariables,
  TContext
> => {
  const mutationKey = ['putAvailableCustomColumns'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putAvailableCustomColumns>>,
    PutAvailableCustomColumnsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return putAvailableCustomColumns(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAvailableCustomColumnsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAvailableCustomColumns>>
>;
export type PutAvailableCustomColumnsMutationBody = AppApiPlatformInteractionsPutAvailableCustomColumnsReq;
export type PutAvailableCustomColumnsMutationError = HTTPValidationError;
export type PutAvailableCustomColumnsMutationVariables = {
  data: AppApiPlatformInteractionsPutAvailableCustomColumnsReq;
};

/**
 * @summary Put Available Custom Columns
 */
export const usePutAvailableCustomColumns = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAvailableCustomColumns>>,
    TError,
    PutAvailableCustomColumnsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putAvailableCustomColumns>>,
  TError,
  PutAvailableCustomColumnsMutationVariables,
  TContext
> => {
  return useMutation(getPutAvailableCustomColumnsMutationOptions(options));
};
export const getDeleteCustomColumnsUrl = () => {
  return `/api/v1/interactions/available-custom-columns`;
};

/**
 * @summary Delete Custom Columns
 */
export const deleteCustomColumns = async (
  deleteAvailableCustomColumnsReq: DeleteAvailableCustomColumnsReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<ResponseMessage> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ResponseMessage>(getDeleteCustomColumnsUrl(), {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deleteAvailableCustomColumnsReq),
  });
};

export const getDeleteCustomColumnsMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomColumns>>,
    TError,
    DeleteCustomColumnsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCustomColumns>>,
  TError,
  DeleteCustomColumnsMutationVariables,
  TContext
> => {
  const mutationKey = ['deleteCustomColumns'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCustomColumns>>,
    DeleteCustomColumnsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return deleteCustomColumns(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCustomColumnsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomColumns>>>;
export type DeleteCustomColumnsMutationBody = DeleteAvailableCustomColumnsReq;
export type DeleteCustomColumnsMutationError = HTTPValidationError;
export type DeleteCustomColumnsMutationVariables = { data: DeleteAvailableCustomColumnsReq };

/**
 * @summary Delete Custom Columns
 */
export const useDeleteCustomColumns = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomColumns>>,
    TError,
    DeleteCustomColumnsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCustomColumns>>,
  TError,
  DeleteCustomColumnsMutationVariables,
  TContext
> => {
  return useMutation(getDeleteCustomColumnsMutationOptions(options));
};
export const getGetInteractionsMultiAggregatesUrl = () => {
  return `/api/v1/interactions/get-interaction-multi-aggregates`;
};

/**
 * Used by the Insights tab of the Overview page (Trending/MostDiscussed).
 * @summary Get Interactions Multi Aggregates
 */
export const getInteractionsMultiAggregates = async (
  getInteractionMultiAggregatesReq: GetInteractionMultiAggregatesReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedGroupByQueryMultiple> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<PaginatedGroupByQueryMultiple>(getGetInteractionsMultiAggregatesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getInteractionMultiAggregatesReq),
  });
};

export const getGetInteractionsMultiAggregatesMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getInteractionsMultiAggregates>>,
    TError,
    GetInteractionsMultiAggregatesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getInteractionsMultiAggregates>>,
  TError,
  GetInteractionsMultiAggregatesMutationVariables,
  TContext
> => {
  const mutationKey = ['getInteractionsMultiAggregates'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getInteractionsMultiAggregates>>,
    GetInteractionsMultiAggregatesMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getInteractionsMultiAggregates(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetInteractionsMultiAggregatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof getInteractionsMultiAggregates>>
>;
export type GetInteractionsMultiAggregatesMutationBody = GetInteractionMultiAggregatesReq;
export type GetInteractionsMultiAggregatesMutationError = HTTPValidationError;
export type GetInteractionsMultiAggregatesMutationVariables = { data: GetInteractionMultiAggregatesReq };

/**
 * @summary Get Interactions Multi Aggregates
 */
export const useGetInteractionsMultiAggregates = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getInteractionsMultiAggregates>>,
    TError,
    GetInteractionsMultiAggregatesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getInteractionsMultiAggregates>>,
  TError,
  GetInteractionsMultiAggregatesMutationVariables,
  TContext
> => {
  return useMutation(getGetInteractionsMultiAggregatesMutationOptions(options));
};
export const getGetInteractionsUrl = () => {
  return `/api/v1/interactions/get-interactions-v2`;
};

/**
 * @summary Get Interactions V2
 */
export const getInteractions = async (
  getInteractionsReq: GetInteractionsReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedInteractionsQueryDetailed> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<PaginatedInteractionsQueryDetailed>(getGetInteractionsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getInteractionsReq),
  });
};

export const getGetInteractionsMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getInteractions>>,
    TError,
    GetInteractionsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getInteractions>>,
  TError,
  GetInteractionsMutationVariables,
  TContext
> => {
  const mutationKey = ['getInteractions'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof getInteractions>>, GetInteractionsMutationVariables> = (
    props,
  ) => {
    const { data } = props ?? {};

    return getInteractions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetInteractionsMutationResult = NonNullable<Awaited<ReturnType<typeof getInteractions>>>;
export type GetInteractionsMutationBody = GetInteractionsReq;
export type GetInteractionsMutationError = HTTPValidationError;
export type GetInteractionsMutationVariables = { data: GetInteractionsReq };

/**
 * @summary Get Interactions V2
 */
export const useGetInteractions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getInteractions>>,
    TError,
    GetInteractionsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getInteractions>>,
  TError,
  GetInteractionsMutationVariables,
  TContext
> => {
  return useMutation(getGetInteractionsMutationOptions(options));
};
export const getGetInteractionTimeSeriesUrl = () => {
  return `/api/v1/interactions/get-interaction-time-series`;
};

/**
 * @summary Get Interaction Time Series
 */
export const getInteractionTimeSeries = async (
  getInteractionTimeSeriesReq: GetInteractionTimeSeriesReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetInteractionTimeSeriesResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GetInteractionTimeSeriesResp>(getGetInteractionTimeSeriesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getInteractionTimeSeriesReq),
  });
};

export const getGetInteractionTimeSeriesMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getInteractionTimeSeries>>,
    TError,
    GetInteractionTimeSeriesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getInteractionTimeSeries>>,
  TError,
  GetInteractionTimeSeriesMutationVariables,
  TContext
> => {
  const mutationKey = ['getInteractionTimeSeries'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getInteractionTimeSeries>>,
    GetInteractionTimeSeriesMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getInteractionTimeSeries(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetInteractionTimeSeriesMutationResult = NonNullable<Awaited<ReturnType<typeof getInteractionTimeSeries>>>;
export type GetInteractionTimeSeriesMutationBody = GetInteractionTimeSeriesReq;
export type GetInteractionTimeSeriesMutationError = HTTPValidationError;
export type GetInteractionTimeSeriesMutationVariables = { data: GetInteractionTimeSeriesReq };

/**
 * @summary Get Interaction Time Series
 */
export const useGetInteractionTimeSeries = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getInteractionTimeSeries>>,
    TError,
    GetInteractionTimeSeriesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getInteractionTimeSeries>>,
  TError,
  GetInteractionTimeSeriesMutationVariables,
  TContext
> => {
  return useMutation(getGetInteractionTimeSeriesMutationOptions(options));
};
export const getGetFavoritesCountUrl = () => {
  return `/api/v1/interactions/favorites-count`;
};

/**
 * @summary Get Favorites Count
 */
export const getFavoritesCount = async (
  favoritesCountReq: FavoritesCountReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<FavoritesCountResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<FavoritesCountResp>(getGetFavoritesCountUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(favoritesCountReq),
  });
};

export const getGetFavoritesCountMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getFavoritesCount>>,
    TError,
    GetFavoritesCountMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getFavoritesCount>>,
  TError,
  GetFavoritesCountMutationVariables,
  TContext
> => {
  const mutationKey = ['getFavoritesCount'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getFavoritesCount>>,
    GetFavoritesCountMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getFavoritesCount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetFavoritesCountMutationResult = NonNullable<Awaited<ReturnType<typeof getFavoritesCount>>>;
export type GetFavoritesCountMutationBody = FavoritesCountReq;
export type GetFavoritesCountMutationError = HTTPValidationError;
export type GetFavoritesCountMutationVariables = { data: FavoritesCountReq };

/**
 * @summary Get Favorites Count
 */
export const useGetFavoritesCount = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getFavoritesCount>>,
    TError,
    GetFavoritesCountMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getFavoritesCount>>,
  TError,
  GetFavoritesCountMutationVariables,
  TContext
> => {
  return useMutation(getGetFavoritesCountMutationOptions(options));
};
export const getGetDefaultTimeRangeUrl = (projectId: string) => {
  return `/api/v1/interactions/${projectId}/default-time-range`;
};

/**
 * @summary Get Default Time Range
 */
export const getDefaultTimeRange = async (
  projectId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<TimeRangeConfig> => {
  return customFetch<TimeRangeConfig>(getGetDefaultTimeRangeUrl(projectId), {
    ...options,
    method: 'GET',
  });
};

export const getGetDefaultTimeRangeQueryKey = (projectId: string) => {
  return [`/api/v1/interactions/${projectId}/default-time-range`] as const;
};

export const getGetDefaultTimeRangeQueryOptions = <
  TData = Awaited<ReturnType<typeof getDefaultTimeRange>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getDefaultTimeRange>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDefaultTimeRangeQueryKey(projectId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDefaultTimeRange>>> = ({ signal }) =>
    getDefaultTimeRange(projectId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getDefaultTimeRange>>, TError, TData> & { queryKey: QueryKey };
};

export type GetDefaultTimeRangeQueryResult = NonNullable<Awaited<ReturnType<typeof getDefaultTimeRange>>>;
export type GetDefaultTimeRangeQueryError = HTTPValidationError;

/**
 * @summary Get Default Time Range
 */

export function useGetDefaultTimeRange<
  TData = Awaited<ReturnType<typeof getDefaultTimeRange>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getDefaultTimeRange>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDefaultTimeRangeQueryOptions(projectId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetInteractionQueryOptionsUrl = (projectId: string) => {
  return `/api/v1/interactions/${projectId}/query-options`;
};

/**
 * Currently used only by the MCP server to get query options for interactions
 * and csv download endpoints without hardcoding them.
 * @summary Get Interaction Query Options
 */
export const getInteractionQueryOptions = async (
  projectId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<InteractionQueryOptions> => {
  return customFetch<InteractionQueryOptions>(getGetInteractionQueryOptionsUrl(projectId), {
    ...options,
    method: 'GET',
  });
};

export const getGetInteractionQueryOptionsQueryKey = (projectId: string) => {
  return [`/api/v1/interactions/${projectId}/query-options`] as const;
};

export const getGetInteractionQueryOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getInteractionQueryOptions>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getInteractionQueryOptions>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInteractionQueryOptionsQueryKey(projectId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInteractionQueryOptions>>> = ({ signal }) =>
    getInteractionQueryOptions(projectId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getInteractionQueryOptions>>, TError, TData> & { queryKey: QueryKey };
};

export type GetInteractionQueryOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getInteractionQueryOptions>>>;
export type GetInteractionQueryOptionsQueryError = HTTPValidationError;

/**
 * @summary Get Interaction Query Options
 */

export function useGetInteractionQueryOptions<
  TData = Awaited<ReturnType<typeof getInteractionQueryOptions>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getInteractionQueryOptions>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInteractionQueryOptionsQueryOptions(projectId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateFieldUrl = () => {
  return `/api/v1/interactions/update-field`;
};

/**
 * Update a specific field of an interaction.
 * @summary Update Field
 */
export const updateField = async (
  updateFieldReq: UpdateFieldReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<ResponseMessage> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ResponseMessage>(getUpdateFieldUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateFieldReq),
  });
};

export const getUpdateFieldMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateField>>,
    TError,
    UpdateFieldMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof updateField>>, TError, UpdateFieldMutationVariables, TContext> => {
  const mutationKey = ['updateField'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateField>>, UpdateFieldMutationVariables> = (
    props,
  ) => {
    const { data } = props ?? {};

    return updateField(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFieldMutationResult = NonNullable<Awaited<ReturnType<typeof updateField>>>;
export type UpdateFieldMutationBody = UpdateFieldReq;
export type UpdateFieldMutationError = HTTPValidationError;
export type UpdateFieldMutationVariables = { data: UpdateFieldReq };

/**
 * @summary Update Field
 */
export const useUpdateField = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateField>>,
    TError,
    UpdateFieldMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof updateField>>, TError, UpdateFieldMutationVariables, TContext> => {
  return useMutation(getUpdateFieldMutationOptions(options));
};
export const getHideModelIssueUrl = () => {
  return `/api/v1/interactions/hide-model-issue`;
};

/**
 * Mark a model issue as ignored for a specific interaction.
 * @summary Hide Model Issue
 */
export const hideModelIssue = async (
  ignoreModelIssueReq: IgnoreModelIssueReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<ResponseMessage> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ResponseMessage>(getHideModelIssueUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ignoreModelIssueReq),
  });
};

export const getHideModelIssueMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hideModelIssue>>,
    TError,
    HideModelIssueMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hideModelIssue>>,
  TError,
  HideModelIssueMutationVariables,
  TContext
> => {
  const mutationKey = ['hideModelIssue'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof hideModelIssue>>, HideModelIssueMutationVariables> = (
    props,
  ) => {
    const { data } = props ?? {};

    return hideModelIssue(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HideModelIssueMutationResult = NonNullable<Awaited<ReturnType<typeof hideModelIssue>>>;
export type HideModelIssueMutationBody = IgnoreModelIssueReq;
export type HideModelIssueMutationError = HTTPValidationError;
export type HideModelIssueMutationVariables = { data: IgnoreModelIssueReq };

/**
 * @summary Hide Model Issue
 */
export const useHideModelIssue = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hideModelIssue>>,
    TError,
    HideModelIssueMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof hideModelIssue>>,
  TError,
  HideModelIssueMutationVariables,
  TContext
> => {
  return useMutation(getHideModelIssueMutationOptions(options));
};
export const getShowModelIssueUrl = () => {
  return `/api/v1/interactions/show-model-issue`;
};

/**
 * Mark a model issue as not ignored for an interaction.
 * @summary Show Model Issue
 */
export const showModelIssue = async (
  ignoreModelIssueReq: IgnoreModelIssueReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<ResponseMessage> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ResponseMessage>(getShowModelIssueUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ignoreModelIssueReq),
  });
};

export const getShowModelIssueMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof showModelIssue>>,
    TError,
    ShowModelIssueMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof showModelIssue>>,
  TError,
  ShowModelIssueMutationVariables,
  TContext
> => {
  const mutationKey = ['showModelIssue'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof showModelIssue>>, ShowModelIssueMutationVariables> = (
    props,
  ) => {
    const { data } = props ?? {};

    return showModelIssue(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ShowModelIssueMutationResult = NonNullable<Awaited<ReturnType<typeof showModelIssue>>>;
export type ShowModelIssueMutationBody = IgnoreModelIssueReq;
export type ShowModelIssueMutationError = HTTPValidationError;
export type ShowModelIssueMutationVariables = { data: IgnoreModelIssueReq };

/**
 * @summary Show Model Issue
 */
export const useShowModelIssue = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof showModelIssue>>,
    TError,
    ShowModelIssueMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof showModelIssue>>,
  TError,
  ShowModelIssueMutationVariables,
  TContext
> => {
  return useMutation(getShowModelIssueMutationOptions(options));
};
export const getAddInteractionLabelUrl = () => {
  return `/api/v1/interactions/labels`;
};

/**
 * Attach a label to a single interaction (idempotent).
 * @summary Add Interaction Label
 */
export const addInteractionLabel = async (
  addInteractionLabelReq: AddInteractionLabelReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<InteractionLabel> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<InteractionLabel>(getAddInteractionLabelUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addInteractionLabelReq),
  });
};

export const getAddInteractionLabelMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addInteractionLabel>>,
    TError,
    AddInteractionLabelMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addInteractionLabel>>,
  TError,
  AddInteractionLabelMutationVariables,
  TContext
> => {
  const mutationKey = ['addInteractionLabel'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addInteractionLabel>>,
    AddInteractionLabelMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return addInteractionLabel(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddInteractionLabelMutationResult = NonNullable<Awaited<ReturnType<typeof addInteractionLabel>>>;
export type AddInteractionLabelMutationBody = AddInteractionLabelReq;
export type AddInteractionLabelMutationError = HTTPValidationError;
export type AddInteractionLabelMutationVariables = { data: AddInteractionLabelReq };

/**
 * @summary Add Interaction Label
 */
export const useAddInteractionLabel = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addInteractionLabel>>,
    TError,
    AddInteractionLabelMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addInteractionLabel>>,
  TError,
  AddInteractionLabelMutationVariables,
  TContext
> => {
  return useMutation(getAddInteractionLabelMutationOptions(options));
};
export const getDeleteInteractionLabelUrl = () => {
  return `/api/v1/interactions/labels`;
};

/**
 * Remove a label from a single interaction.
 * @summary Delete Interaction Label
 */
export const deleteInteractionLabel = async (
  deleteInteractionLabelReq: DeleteInteractionLabelReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<ResponseMessage> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ResponseMessage>(getDeleteInteractionLabelUrl(), {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deleteInteractionLabelReq),
  });
};

export const getDeleteInteractionLabelMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInteractionLabel>>,
    TError,
    DeleteInteractionLabelMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInteractionLabel>>,
  TError,
  DeleteInteractionLabelMutationVariables,
  TContext
> => {
  const mutationKey = ['deleteInteractionLabel'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInteractionLabel>>,
    DeleteInteractionLabelMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return deleteInteractionLabel(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInteractionLabelMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInteractionLabel>>>;
export type DeleteInteractionLabelMutationBody = DeleteInteractionLabelReq;
export type DeleteInteractionLabelMutationError = HTTPValidationError;
export type DeleteInteractionLabelMutationVariables = { data: DeleteInteractionLabelReq };

/**
 * @summary Delete Interaction Label
 */
export const useDeleteInteractionLabel = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInteractionLabel>>,
    TError,
    DeleteInteractionLabelMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInteractionLabel>>,
  TError,
  DeleteInteractionLabelMutationVariables,
  TContext
> => {
  return useMutation(getDeleteInteractionLabelMutationOptions(options));
};
export const getGetAvailableInteractionLabelsUrl = () => {
  return `/api/v1/interactions/get-available-labels`;
};

/**
 * Return all distinct interaction labels currently used in this project.
 * @summary Get Available Interaction Labels
 */
export const getAvailableInteractionLabels = async (
  getAvailableInteractionLabelsReq: GetAvailableInteractionLabelsReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetAvailableInteractionLabelsRes> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GetAvailableInteractionLabelsRes>(getGetAvailableInteractionLabelsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getAvailableInteractionLabelsReq),
  });
};

export const getGetAvailableInteractionLabelsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAvailableInteractionLabels>>,
    TError,
    GetAvailableInteractionLabelsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAvailableInteractionLabels>>,
  TError,
  GetAvailableInteractionLabelsMutationVariables,
  TContext
> => {
  const mutationKey = ['getAvailableInteractionLabels'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAvailableInteractionLabels>>,
    GetAvailableInteractionLabelsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getAvailableInteractionLabels(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAvailableInteractionLabelsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAvailableInteractionLabels>>
>;
export type GetAvailableInteractionLabelsMutationBody = GetAvailableInteractionLabelsReq;
export type GetAvailableInteractionLabelsMutationError = HTTPValidationError;
export type GetAvailableInteractionLabelsMutationVariables = { data: GetAvailableInteractionLabelsReq };

/**
 * @summary Get Available Interaction Labels
 */
export const useGetAvailableInteractionLabels = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAvailableInteractionLabels>>,
    TError,
    GetAvailableInteractionLabelsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getAvailableInteractionLabels>>,
  TError,
  GetAvailableInteractionLabelsMutationVariables,
  TContext
> => {
  return useMutation(getGetAvailableInteractionLabelsMutationOptions(options));
};
